import { rootLinks } from '@map/components/app/links';
import { useLogout } from '@map/hooks/auth';
import { useCurrentUser } from '@map/hooks/userApi';
import NotFound from '@shared/components/NotFound/NotFound';
import Button from '@ui/Button';
import NavButton from '@ui/NavButton';
import { FormattedMessage } from 'react-intl';
import { guestLinks } from './GuestArea/links';

const NotFoundPage = () => {
  const user = useCurrentUser();
  const [handleLogout, isBusy] = useLogout();
  return (
    <NotFound>
      {user.id ? (
        <>
          <NavButton size="medium" to={rootLinks.root()}>
            <FormattedMessage id="page_not_found.back_link" />
          </NavButton>
          <Button variant="tertiary" onClick={handleLogout} disabled={isBusy}>
            <FormattedMessage id="logout.submit_button" />
          </Button>
        </>
      ) : (
        <NavButton size="medium" to={guestLinks.authentication()}>
          <FormattedMessage id="login.submit_button" />
        </NavButton>
      )}
    </NotFound>
  );
};

export default NotFoundPage;
